import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
import { unitSchema } from './unit.js';
const idRef = z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak');
/**
 * Nomenklatura va kategoriya kodi — hujjatlarda uchraydi, shuning uchun qat'iy.
 *
 * KIRILL HARFLARI ham qabul qilinadi (`\u0400-\u04FF`). Sabab qog'ozdan
 * keladi: MTU dan tushadigan aktlar va 1C dagi ma'lumotnomalar ruscha
 * kirillda yoziladi va kodlar aynan o'sha ko'rinishda kiritiladi
 * (`ШПАЛ-Б-2500`). Faqat lotin bo'lganda omborchi kodni o'zi
 * transliteratsiya qilishga majbur bo'lardi — va har kim boshqacha
 * qilardi, natijada bitta mahsulot ikki kod bilan katalogga tushardi.
 *
 * Diapazon ATAYLAB tor: `\p{L}` istalgan alifboni ochib yuborardi, bu
 * yerda esa faqat ikki alifbo bor va kod hujjatga bosiladi.
 */
export const CODE_PATTERN = /^[A-Za-z0-9\u0400-\u04FF][A-Za-z0-9\u0400-\u04FF._-]{1,39}$/;
const codeSchema = z
    .string()
    .regex(CODE_PATTERN, 'Kod harf/raqam bilan boshlanib, 40 belgidan oshmasligi kerak');
export const nomenclatureSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    unit: unitSchema,
    categoryId: z.string().nullable(),
    minStock: z.number(),
    isActive: z.boolean(),
});
export const nomenclatureCategorySchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    parentId: z.string().nullable(),
});
export const nomenclatureQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(200).optional(),
    categoryId: idRef.optional(),
});
export const createNomenclatureSchema = z.object({
    code: codeSchema,
    name: z.string().min(2).max(300),
    unit: unitSchema,
    categoryId: idRef.nullable().optional(),
    /** Ogohlantirish chegarasi ("kam qoldiq") — qoldiqni cheklamaydi. */
    minStock: z.number().nonnegative().max(1_000_000_000).optional(),
});
/**
 * Kod ham, BIRLIK ham tahrirda YO'Q.
 *
 * Kod hujjatlarda va Excel importida ishlatiladi. Birlik esa qoldiqning
 * ma'nosi: `120` soni `kg` dan `dona` ga aylanganda mavjud partiyalar
 * jimgina noto'g'ri o'qiladi. Birlik xato kiritilgan bo'lsa, nomenklatura
 * arxivlanadi (`isActive: false`) va yangisi ochiladi.
 */
export const updateNomenclatureSchema = z.object({
    name: z.string().min(2).max(300).optional(),
    categoryId: idRef.nullable().optional(),
    minStock: z.number().nonnegative().max(1_000_000_000).optional(),
    isActive: z.boolean().optional(),
});
export const nomenclatureCategoryQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(200).optional(),
});
export const createNomenclatureCategorySchema = z.object({
    code: codeSchema,
    name: z.string().min(2).max(200),
    parentId: idRef.nullable().optional(),
});
//# sourceMappingURL=catalog.schema.js.map